// extracted by mini-css-extract-plugin
var _1 = "SCIMTab-module__regenerateToken--YV7T0";
var _2 = "SCIMTab-module__scimToken--WIwo6";
export { _1 as "regenerateToken", _2 as "scimToken" }
